import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { FormularioLoginComponent } from './formulario-login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from "../../app-routing.module";

@NgModule({
    imports: [BrowserModule, FormsModule, ReactiveFormsModule, AppRoutingModule],
    declarations: [FormularioLoginComponent],
    exports: [FormularioLoginComponent],
    bootstrap: [FormularioLoginComponent]
})
export class FormularioLoginModule {}
